<template>
  <div>
    <v-row :class="{'pl-11': type, 'pl-4': !type}" class="board__card-title pr-1 pt-1" no-gutters>
      <v-col class="d-flex align-start" cols="10">
        <BoardItemIcon v-if="type" :type="type" />
        <span class="d-block subtitle-2 mr-2 grey--text text--darken-3">
          <p v-if="type" class="board__card-type text-truncate">
            {{ $t(`appointment.type.${type}`) }}
          </p>
          {{ timeSlot(date, slotSize) }}
          <span class="grey--text caption">#{{ code }}</span>
        </span>
      </v-col>
      <v-col v-if="menu" class="text-right" cols="2">
        <MenuAppointment :appointment="appointment" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BoardItemIcon from '../../BoardItemIcon'
import MenuAppointment from '@/components/appointment/MenuAppointment'

import { timeSlot } from '@/util/catalog'

export default {
  name: 'BoardCardTitle',

  components: {
    BoardItemIcon,
    MenuAppointment,
  },

  props: {
    date: {
      type: String,
      require: true,
    },

    slotSize: {
      type: Number | String,
      required: false,
    },

    code: {
      type: Number,
      required: true,
    },

    type: {
      type: String,
      require: true,
    },

    itemId: {
      type: String,
      required: false,
    },

    column: {
      type: String,
      required: false,
    },

    menu: {
      type: Boolean,
      required: false,
      default: true,
    },

    hasVisitorOrTenant: {
      type: Boolean,
    },

    appointment: {
      type: Object,
      required: false,
    },
  },

  data() {
    return {
      timeSlot,
    }
  },
}
</script>
